<template>
  <div class="template">
    <div class="content wx">
      <el-tooltip class="item" effect="dark" content="切换经典页面" placement="right">
        <el-button type="primary" class="content_button" size="mini" @click="showAll = false" circle>
          <img src="../../assets/images/switch.png" alt="">
        </el-button>
      </el-tooltip>
      <div class="left boxall">
        <el-table 
          class="table" 
          height="100%" 
          :data="tableData" 
          :row-style="rowStyle" 
          :cell-style="cellStyle" 
          :header-cell-style="{background:'rgba(0,0,0,.2)',color:'#fff'}"
        >
          <el-table-column label="名称" prop="name"></el-table-column>
          <el-table-column label="数值" prop="data"></el-table-column>
          <el-table-column label="时间" prop="ts"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="right">
                <el-button @click="edit(scope.row)" type="text" icon="el-icon-bj" size="small"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="boxfoot"></div>
      </div>
      <div class="right">
        <div class="alert boxall">
          <!-- <el-date-picker
            class="block"
            v-model="date"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            size="small"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          <el-button type="primary" size="mini" class="find_button" @click="getHistoryAlarmData">查询</el-button> -->
          <el-table 
            class="table" 
            height="80%" 
            :data="historyTableData" 
            :row-style="{height: '0'}" 
            :cell-style="cellStyle" 
            :header-cell-style="{background:'rgba(0,0,0,.2)',color:'#fff'}"
          >
            <el-table-column label="名称" prop="alarm_name" :show-overflow-tooltip="true" width="140px"></el-table-column>
            <el-table-column label="数值" prop="alarm_value" width="60px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="状态" prop="alarm_status" width="80px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <p>{{scope.row.alarm_status == 'on' ? '已触发' : '已恢复'}}</p>
              </template>
            </el-table-column>
            <el-table-column label="时间" prop="date" :show-overflow-tooltip="true" width="160px"></el-table-column>
            <el-table-column label="描述" prop="alarm_content" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              layout="total, prev, pager, next, jumper"
              :current-page="page"
              :page-size="size"
              :total="count"
              @current-change="changePage"
            ></el-pagination>
          </div>
          <div class="boxfoot"></div>
        </div>
        <div class="charts boxall">
          <h1>实时数据趋势图</h1>
          <realDataCharts width="100%" height="90%" color="#fff" xycolor="#fff"/>
          <div class="boxfoot"></div>
        </div>
      </div>
    </div>
    <el-dialog title="修改数值" :visible.sync="dialogEditData" width="30%">
      <el-form :model="form" label-position="right" label-width=".8rem" ref="edit" :rules="editRules">
        <el-form-item label="名称" prop="value">
          <el-input type="text" class="yl-input_noIcon" size="small" placeholder="请输入数值" v-model="form.value" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editCanel" class="yl-button2" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" class="yl-button" @click="editData()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DataService from '@/api/data'
import realDataCharts from '@/components/realDataAll/realDatacharts'
import { utils } from "@/utils/index.js";
export default {
  components:{
    realDataCharts
  },
  props:{
    serial_number:String
  },
  data(){
    return{
      pc:1,
      dialogEditData:false,
      page:1,
      size:10,
      count:0,
      showAll:true,
      tableData:[],
      historyTableData:[],
      timer:'',
      date:[],
      form:{
        value:''
      },
      variableName:'',//修改的变量名称
      editRules:{
        value:[{ required: true,message: '请输入数值', trigger: 'blur' }]
      }
    }
  },
  computed:{
    activeRouter(){
      return this.$route.path;
    }
  },
  methods:{
    rowStyle(){
      return
    },
    cellStyle(){
      return "padding:5px;color:#fff;"
    },
    getData(){
      DataService.realData({
        serialNumber:this.serial_number,
        }).then(res=>{
        this.tableData = res.data;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page){
      this.page = page;
      this.getHistoryAlarmData();
    },
    //获取实时告警数据
    getHistoryAlarmData(){
      DataService.getAlarmData({
        user_id:this.$store.state.user_id,
        serialNumber:this.serial_number,
        status:0,
        page:this.page,
        size:this.size,
      }).then(res=>{
        this.historyTableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
    edit(val){
      this.dialogEditData = true;
      this.form.value = val.data;
      this.variableName = val.name;
    },
    //取消修改
    editCanel(){
      this.dialogEditData = false;
      this.$refs.edit.resetFields();
    },
    //修改实时数据数值
    editData(){
      DataService.updateVariableValues({
        serialNumber:this.serial_number,
        user_id:this.$store.state.user_id,
        variableName:this.variableName,
        value:this.form.value
      }).then(res=>{
        this.dialogEditData = false;
        this.$message.success('修改成功');
        this.getData()
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    //获取最新时间
    showTime() {
      this.date = []
      this.date.push(...utils.getDate());
    }
  },
  mounted(){
    this.getData()
    this.showTime()
    this.getHistoryAlarmData()
    let _this = this;
    this.timer = setInterval(function(){
		  _this.getData();
      // _this.showTime();
      _this.getHistoryAlarmData();
	  }, 10000);
    // 移动端 
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('mobi') !=-1) { 
    // 手机浏览器 
      console.log('手机')
      this.pc = 0;
    } else { 
      // 非手机浏览器 
      console.log('非手机') 
      this.pc = 1;
    } 
  },
  beforeDestroy(){
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.wx{
  height: 100vh;
}
.content{
  width: 100vw;
  background:url(../../assets/images/bg.png);
  display: flex;
  padding: 0 50px;
  justify-content: space-between;
  .content_button{
    position: absolute;
    top: 80px;
    left: 10px;
    width: 30px;
    height: 30px;
    img{
      width: 100%;
    }
  }
  .left{
    width: 54vw;
    height: 98%;
    padding: 16px;
    background:rgba(0,0,0,.2);
    /deep/ .el-table--fit{
      padding:0 20px;
    }
    /deep/  .el-table, .el-table__expanded-cell {
        background-color: transparent;
    }

    /deep/ .el-table tr {
        background-color: transparent!important;
    }
    /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{
      background-color: transparent;
    }
    /deep/ .el-table::before {//去除底部白线
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0px;
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
      background-color: #212e3e !important;
    }
    .table{
      width: 100%;
      height: 100%;
    }
  }
  .right{
    width: 40vw;
    height: 98%;
    padding-left:16px;
    .alert{
      width: 100%;
      height: 48%;
      margin-bottom: 5%;
      background:rgba(0,0,0,.2);
      padding: 10px;
      // .find_button{
      //   position: absolute;
      //   top: 14px;
      //   left: 396px;
      // }
      // .block{
      //   width:372px;
      //   color: white;
      //   background-color:#000;
      //   /deep/ .el-picker-panel__icon-btn {
      //     font-size: 12px;
      //   }
      //   /deep/.el-input__inner{
      //     height:32px;
      //   }
      //   /deep/.el-range-input{
      //     color: #fff;
      //     background: #1A1540;
      //   }
      //   /deep/ .el-range-separator{
      //     color: #fff;
      //   }
      // }
      /deep/ .el-table--fit{
        padding:0 20px;
        margin-top: 20px;
      }
      /deep/  .el-table, .el-table__expanded-cell {
        background-color: transparent;
      }
      /deep/ .el-table tr {
        background-color: transparent!important;
      }
      /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{
        background-color: transparent;
      }
      /deep/ .el-table::before {//去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
      }
      /deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
        background-color: #212e3e !important;
      }
      /deep/ .el-pagination__total{ //分页总条数字体颜色
        color: #fff;
      }
      /deep/ .btn-prev {
        background-color:transparent ;
        color: #fff;
      }
      /deep/ .btn-next{
        background-color:transparent ;
        color: #fff;
      }
      /deep/ .el-input__inner{ //分页输入页数跳转输入框背景颜色字体颜色
        background-color:transparent ;
        color: #fff;
      }
      /deep/ .el-pagination__jump{ //分页输入页数跳转字体颜色
        color: #fff;
      }
      /deep/ .el-pager li.active{
        background-color:rgba(0,0,0,0);
        border: solid 1px #fff;
        border-radius: 4px;
        color: #fff;
      }
      /deep/ .el-pager li{
        background-color:transparent;
        color: #fff;
        min-width: 28px;
      }
      .pagination{
        margin-top: 5px;
      }
    }
    .charts{
      width: 100%;
      height: 48%;
      background:rgba(0,0,0,.2);
      h1{
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        color: #fff;
        padding: 6px 0;
      }
    }
  }
}
.boxall{ 
  border: 1px solid rgba(25,186,139,.17); 
  padding:0 3.2px 6.4px 2.4px;  
  background: rgba(255,255,255,.4); 
  background-size: 100% auto; 
  position: relative; 
  margin-bottom: 2.4px; 
  z-index: 10;
}
.boxall::before,
.boxall:after{ position:absolute; width: 10px; height: 10px; content: "";  border-top: 2px solid #02a6b5; top: 0;}
.boxall:before,.boxfoot:before{border-left: 2px solid #02a6b5;left: 0;}
.boxall:after,.boxfoot:after{border-right: 2px solid #02a6b5; right: 0;}
.boxfoot{ position:absolute; bottom: 0; width: 100%; left: 0;}
.boxfoot:before,
.boxfoot:after{ position:absolute; width: 10px; height: 10px;  content: "";border-bottom: 2px solid #02a6b5; bottom: 0;}
</style>